import { setupGuideStatusSchema, type SetupGuideStatus } from "@io-spoke/contracts/setupGuide";
import { getApiClient } from "./apiClient";

export async function getSetupGuideStatus(): Promise<SetupGuideStatus> {
  const response = await getApiClient().get<unknown>("/setup-guide");
  const parsed = setupGuideStatusSchema.safeParse(response.data);
  if (!parsed.success) throw new Error("Setup guide returned an invalid response.");
  return parsed.data;
}
